import {inject, Pipe, PipeTransform} from '@angular/core';
import {resolveWalletLabel, Wallet, WalletRef} from '@gatewee/types/wallet';
import {TranslateService} from '@ngx-translate/core';
import {ProviderPipe} from './provider.pipe';

@Pipe({
  name: 'walletLabel',
  standalone: false,
})
export class WalletLabelPipe implements PipeTransform {
  private readonly providerPipe = inject(ProviderPipe);
  private readonly translate = inject(TranslateService);

  transform(wallet: Wallet | WalletRef | null | undefined): string {
    return resolveWalletLabel(wallet, {
      providerLabel: provider => this.providerPipe.transform(provider),
      fallbackLabel: id =>
        this.translate.instant('common.table.walletFallback', {id}),
    });
  }
}
